<template>
    <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Dog Age
          </th>
          <th class="text-left">
            Full Member Price<br/>
            (per sire)
          </th>
          <th class="text-left">
            Service Member Price<br/>
            (per sire)
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, idx) in priceInfo"
          :key="idx"
        >
          <td>{{ item.dogAge }}</td>
          <td>${{ item.fullMemberPrice }}</td>
          <td>${{ item.serviceMemberPrice }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
    name: 'DogRegistrationFeeTable',
    props: {
        priceInfo: Array,
    }
})
</script>